// Cálculo compartilhado para o formulário, as consultas e os PDFs dos atos.
// Usa datas do calendário sem conversão de fuso e não arredonda dias restantes.

const lerDataCalendario = (valor) => {
  if (!valor) return null;

  const texto = String(valor).slice(0, 10);

  if (!/^\d{4}-\d{2}-\d{2}$/.test(texto)) return null;

  const data = new Date(`${texto}T00:00:00Z`);

  if (
    Number.isNaN(data.getTime()) ||
    data.toISOString().slice(0, 10) !== texto
  ) {
    return null;
  }

  return data;
};

export const calcularMesesValidade = (inicio, fim) => {
  const dataInicio = lerDataCalendario(inicio);
  const dataFim = lerDataCalendario(fim);

  if (!dataInicio || !dataFim || dataInicio > dataFim) return null;

  let meses =
    (dataFim.getUTCFullYear() - dataInicio.getUTCFullYear()) * 12 +
    dataFim.getUTCMonth() -
    dataInicio.getUTCMonth();

  // Quando o dia inicial não existe no mês final, usa o último dia desse mês.
  // Exemplo: 31/01 a 28/02 de um ano não bissexto corresponde a um mês.
  const ultimoDiaDoMes = new Date(dataFim);
  ultimoDiaDoMes.setUTCMonth(dataFim.getUTCMonth() + 1, 0);

  const diaAniversario = Math.min(
    dataInicio.getUTCDate(),
    ultimoDiaDoMes.getUTCDate(),
  );

  if (dataFim.getUTCDate() < diaAniversario) meses -= 1;

  return meses;
};

export const formatarPrazoValidade = (inicio, fim) => {
  const meses = calcularMesesValidade(inicio, fim);

  if (meses === null) return "";
  if (meses === 0) return "Menos de 1 mês";

  if (meses < 24) {
    return `${meses} ${meses === 1 ? "mês" : "meses"}`;
  }

  const anos = Math.floor(meses / 12);
  const mesesRestantes = meses % 12;
  const prazoEmAnos = `${anos} anos`;

  if (mesesRestantes === 0) return prazoEmAnos;

  return `${prazoEmAnos} e ${mesesRestantes} ${
    mesesRestantes === 1 ? "mês" : "meses"
  }`;
};
